import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CampaignLaunchResponseDataSchema, CreateCampaignLaunchSchema, DataResponse } from "schema"
import { z } from "zod"
import { getCampaignQueryKey } from "../lib/campaignQuery"

export function useCreateCampaignLaunchMutation(campaignId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof CreateCampaignLaunchSchema>) => {
      const response = await axios.post<
        DataResponse<z.infer<typeof CampaignLaunchResponseDataSchema>>
      >(`/campaigns/${campaignId}/launches`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(campaignId) })
    },
  })
}
